import { render, staticRenderFns } from "./remove-draft-confirm.vue?vue&type=template&id=7fc873dc&"
import script from "./remove-draft-confirm.vue?vue&type=script&lang=js&"
export * from "./remove-draft-confirm.vue?vue&type=script&lang=js&"
import style0 from "./remove-draft-confirm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports